var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.764,
    height: 20.6,
    viewBox: "0 0 24.764 20.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "view-icon",
    d: "M13.366,0A12.594,12.594,0,0,1,25.748,10.3a12.592,12.592,0,0,1-24.764,0A12.593,12.593,0,0,1,13.366,0Zm0,18.311A10.306,10.306,0,0,0,23.411,10.3a10.306,10.306,0,0,0-20.09,0,10.306,10.306,0,0,0,10.045,8.011Zm0-2.861a5.15,5.15,0,1,1,3.642-1.508A5.15,5.15,0,0,1,13.366,15.45Zm0-2.289a2.861,2.861,0,1,0-2.023-.838A2.861,2.861,0,0,0,13.366,13.161Z",
    transform: "translate(-0.984)",
    fill: "#948fb5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view-icon.5a1457e0b3728e340b4bba08e51480d8.svg";
export { ForwardRef as ReactComponent };